import { theme } from 'antd'

const defaultIconOffset = 4

export const useIconSizes = () => {
  const { token } = theme.useToken()
  const defaultSize = token.fontSizeIcon + defaultIconOffset

  return {
    extraSmall: defaultSize - 4,
    small: defaultSize - 2,
    default: defaultSize,
    medium: defaultSize + 2,
    large: defaultSize + 4,
    extraLarge: defaultSize + 8
  } as const
}
